import { call, put, takeEvery } from 'redux-saga/effects';
import { deleteLeadRequest } from '../../requests/delete_lead_request';
import {
    deleteLeadSuccess,
    deleteLeadFailure,
} from '../actions/delete_lead.actions';
import { DELETE_LEAD_REQUEST } from '../constants/delete_lead.constants';
import { message_error, message_success } from '../../../../../components/Message';

function* deleteLead({ leadId }) {
    const result = yield call(deleteLeadRequest, leadId);
    if (!result.error) {
        yield put(deleteLeadSuccess(result));
        message_success('Lead successfully deleted!');
    } else {
        yield put(deleteLeadFailure(result.error));
        message_error(`${result.msg}: ${result.error}`);
    }
}

export default function* deleteLeadSaga() {
    yield takeEvery(DELETE_LEAD_REQUEST, deleteLead);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/sagas/delete_lead.saga.js